import { ValueOf } from '@/types/util';

export const accountStatus = {
  AVAILABLE: '使用中',
  WITHDRAWAL: '削除',
} as const;

export type AccountStatusKey = keyof typeof accountStatus;
export type AccountStatusValue = ValueOf<typeof accountStatus>;

export const accountStatusKeys = Object.keys(accountStatus) as AccountStatusKey[];

/** v-select用items */
export const accountStatusItems = accountStatusKeys
  .map((key) => ({
    title: accountStatus[key],
    value: key,
  }));
